import React, { Component, useMemo } from 'react';
import { Col, Container, Row, Card, CardBody, ButtonToolbar, Button, ModalHeader } from 'reactstrap';
//import Button from '@material-ui/core/Button';
import { Field, reduxForm, reset } from 'redux-form';
import { withTranslation } from 'react-i18next';
import renderSelectField from '../../../../shared/components/form/Select';
import DataReactTable from './DataReactTable';
import AttachFileTableActions from './AttachFileTableActions';
import AddFileAdmision from './AddFileAdmision'
import moment from 'moment';
import { KeyboardDatePicker, MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import history from '../../../../history';
import Spinner from 'react-bootstrap/Spinner';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Grid from '@material-ui/core/Grid';
import { every } from 'lodash';

class AttachFileAdmission extends Component {
    constructor(props) {
        super(props);
        this.state = {
            documentClass: null,
            file: null,
            description: "",
            dataPatient: null,
            typeImg: '',
            date: new Date,
            data: [],
            errors: {},
            isLoading: true,
            openModalAddFile: false,
            profile: sessionStorage.getItem('perfil')
        }
    };//

    componentDidMount() {
        this.setState({ dataPatient: this.props.location.state.dataPatient });
        console.log(this.props.location.state);
        this.getDataFiles();
        console.log("PERFIL", this.state.profile);

    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.file !== this.state.file) {
            this.addFile()
        }
    }
    

    addFile = () =>{
        const errors = {};
        let error = false;
        if (this.state.file == null) {
            errors.file = "Seleccione un archivo";
            error = true;
        }
        this.setState({ errors: errors });
        
        if(error){
            return ;
        }
        this.setState({openModalAddFile: !this.state.openModalAddFile})

    }

    uploadFile = (formFiles) => {
            const user = JSON.parse(sessionStorage.getItem('usuario'));
            var dataFile = new FormData();

            for (let index = 0; index < formFiles.length; index++) {
                dataFile.append("archivo", formFiles[index].file);
                dataFile.append("id_historia", parseInt(this.state.dataPatient.id_historia));
                dataFile.append("id_admision", parseInt(this.state.dataPatient.id_admision));
                dataFile.append("descripcion", formFiles[index].description);
                dataFile.append("clase", formFiles[index].documentClass.value);
                dataFile.append("tipo", formFiles[index].typeImg);
                dataFile.append("fecha", moment(this.state.date).format("YYYY/MM/DD"));
                dataFile.append("hora", moment(this.state.date).format("HH:MM A"));
                dataFile.append("usuario", user.usuario);              
            }        
            
            fetch(process.env.REACT_APP_PUBLIC_URL + 'archivos/create', {
                method: 'POST',
                headers: {
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: dataFile
            })
                .then(response => {
                    return response.text();
                })
                .then(data => {
                    console.log(data);
                    alert("archivo creado correctamente");
                    this.getDataFiles()
                    this.props.dispatch(reset("attach_file_admission_form"))
                    /* history.push({
                        pathname: process.env.PUBLIC_URL + '/assitencial/admissions',
                        state: { date: this.props.location.state.dataPatient.fecha }
                    }); */
                });
        
    }

    getDataFiles = () => {

        let dataSend = {
            id_historia: parseInt(this.props.location.state.dataPatient.id_historia),
            id_admision: 0
        };

        console.log(dataSend);
        fetch(process.env.REACT_APP_PUBLIC_URL + 'archivos/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                this.createDatateble(data.contenido);

            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    renameFile = (originalFile, newName) => {
        return new File([originalFile], newName, { type: originalFile.type, lastModified: originalFile.lastModified });
    }

    createDatateble = (data) => {

        let filterData = [];

        for (let i = 0; i < data.length; i++) {
            if (data[i].archivos !== null) {
                for (let j = 0; j < data[i].archivos.archivos.length; j++) {
                    filterData.push({...data[i].archivos.archivos[j], id_admision: data[i].id_admision});
                }
            }
        }
        this.setData(filterData);
    }

    setData = (data) => {

        let filterData = [];

        for (let i = 0; i < data.length; i++) {
            filterData[i] = {

                clase: data[i].clase === "1" ? "CONSENTIMIENTO INFORMADO" :
                    data[i].clase === "2" ? "ECOCARDIOGRAMA MODO M" :
                        data[i].clase === "3" ? "ECOCARDIOGRAMA STRESS" :
                            data[i].clase === "4" ? "ELECTROCARDIOGRAMAS" :
                                data[i].clase === "5" ? "FORMULA MEDICA" :
                                    data[i].clase === "6" ? "HISTORIA CLINICA" :
                                        data[i].clase === "7" ? "HOLTER CARDIACO" :
                                            data[i].clase === "8" ? "IMAGENOLOGIA" :
                                                data[i].clase === "9" ? "LABORATORIO CLINICO" :
                                                    data[i].clase === "10" ? "MONITOREO DE PRESION ARTERIAL" :
                                                        data[i].clase === "11" ? "ORDEN MEDICA" :
                                                            data[i].clase === "12" ? "GAMAGRAFIAS" : 
                                                            data[i].clase === "13" ? "RESONANCIA NUCLERA MAGNETICA" : 
                                                            data[i].clase === "14" ? "DOCUMENTO DE IDENTIDAD" :
                                                            data[i].clase === "15" ? "AUTORIZACION" :
                                                            data[i].clase === "16" ? "OTROS" :
                                                            "",
                fecha: data[i].fecha,
                hora: data[i].hora,
                nombre: data[i].fileName,
                usuario: typeof data[i].usuario !== 'undefined' ? data[i].usuario : "",
                descripcion: data[i].descripcion,
                ruta: data[i].ruta,
                id: data[i].id,
                id_admision: data[i].id_admision
            }
        }

        console.log("dataFilter", filterData);


        this.setState({ data: filterData, isLoading: false });
    }

    handlerDate = (date) => {
        this.setState({ date: date });
    }

    render() {
        const reactTableData = {
            tableHeaderData: [
                {
                    Header: 'CLASE DE DOCUMENTO',
                    accessor: 'clase',
                    disableGlobalFilter: true,
                    width: 65,
                },
                {
                    Header: 'FECHA',
                    accessor: 'fecha',
                },
                {
                    Header: 'HORA',
                    accessor: 'hora',
                },
                {
                    Header: 'NOMBRE',
                    accessor: 'nombre',
                },
                {
                    Header: 'DESCRIPCIÓN',
                    accessor: 'descripcion',
                },
                {
                    Header: 'USUARIO',
                    accessor: 'usuario',
                },
            ],
            tableRowsData: this.state.data
        };

        return (
            <Container className="dashboard">
                <Row>
                    <Col md={12}>
                        <h3 style={{ marginBottom: 30 }}>Anexar archivos</h3>
                        {
                            this.props.location.state.previousUrl === '/assitencial/search-clinic-history' ?
                                <Button
                                    style={{ marginBottom: 20 }}
                                    color="primary"
                                    size="sm"
                                    onClick={() => {
                                        history.push({
                                            pathname: process.env.PUBLIC_URL + '/assitencial/search-clinic-history',
                                            state: {
                                                date: this.props.location.state.dataPatient.fecha,
                                                estado_list_form: this.props.location.state.dataPatient.estado_list_form,
                                                pageIndex: this.props.location.state.pageIndex
                                            }
                                        });
                                    }}
                                ><ArrowBackIcon />
                                </Button>
                                :
                                <Button
                                    style={{ marginBottom: 20 }}
                                    color="primary"
                                    size="sm"
                                    onClick={() => {
                                        history.push({
                                            pathname: process.env.PUBLIC_URL + '/assitencial/admissions',
                                            state: {
                                                date: this.props.location.state.dataPatient.fecha,
                                                estado_form: this.props.location.state.dataPatient.estado_form,
                                                indexPageF: this.props.location.state.indexPage
                                            }
                                        });
                                    }}
                                ><ArrowBackIcon />
                                </Button>
                        }
                    </Col>
                </Row>
                <Row>
                    <Card> 
                        <CardBody>
                            <div className="form" style={{ display:'flex', flexDirection: 'column' }}>
                                <h4>INFORMACIÓN DE PACIENTE</h4>
                                <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10 }}>
                                    {this.state.dataPatient !== null ?
                                        <div style={{ display: 'flex' }}>
                                            <div style={{ marginRight: 10 }}><h4> {this.state.dataPatient.tip_documento}-{this.state.dataPatient.num_documento}</h4></div>
                                            <div><h4>{this.state.dataPatient.fullname} </h4> </div>
                                        </div> : null}
                                </div>
                            </div> 
                            <Grid container >
                                <Grid item xs={2}>   
                                    <MuiPickersUtilsProvider utils={MomentUtils} >
                                        <DatePicker
                                            label="FECHA"
                                            value={this.state.date}
                                            onChange={(date) => {
                                                this.handlerDate(date);
                                            }}
                                            format="yyyy/MM/DD"
                                            animateYearScrolling
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item xs={10} style={{paddingTop:5}}>                     
                                            <span className="form__form-group-label">
                                                AGREGAR ARCHIVO
                                            </span>
                                            <div className="form__form-group-field" >    
                                                <input
                                                    type="file"
                                                    multiple
                                                    onChange={(e) => {
                                                        //console.log(e.target.files);
                                                        this.setState({ file: e.target.files }); 
                                                    }}
                                                />
                                            </div>
                                            <span className="form__form-group-label" style={{ color: 'red' }}>
                                                {this.state.errors.hasOwnProperty("file") ? this.state.errors.file : ""}
                                            </span>
                                            
                                </Grid>
                                <AddFileAdmision open={this.state.openModalAddFile} toggle={this.addFile} archivo={this.state.file} uploadFile={this.uploadFile}  documento={this.state.documentClass}/>
                              
                            </Grid>
                                    
                            <div>
                                {this.state.isLoading ? (<Spinner animation="border" variant="success" />)
                                    : <DataReactTable
                                        Callback={this.getDataFiles}
                                        title={'Documentos Cargados'}
                                        reactTableData={reactTableData}
                                        ReactTableActions={AttachFileTableActions} />}

                            </div>
                        </CardBody>
                    </Card>
                </Row>
            </Container>
        );
    }
};
export default reduxForm({
    form: 'attach_file_admission_form', // a unique identifier for this form
})(withTranslation('common')(AttachFileAdmission));